module.exports = "<render-image [element]=\"element\"></render-image>"